import { StoreState } from '@/redux/types';
import { getProductTypeDiscounts } from './getProductTypeDiscounts';

export const selectProductTypeDiscounts = (productTypeId: string) => (state: StoreState) =>
  getProductTypeDiscounts(state, productTypeId) || [];
